import type { ReactNode } from 'react';

export const symbol_user_attributes: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M562-700q-13 0-21.5-8.5T532-730q0-13 8.5-21.5T562-760h288q13 0 21.5 8.5T880-730q0 13-8.5 21.5T850-700H562Zm0 160q-13 0-21.5-8.5T532-570q0-13 8.5-21.5T562-600h288q13 0 21.5 8.5T880-570q0 13-8.5 21.5T850-540H562Zm0 160q-13 0-21.5-8.5T532-410q0-13 8.5-21.5T562-440h288q13 0 21.5 8.5T880-410q0 13-8.5 21.5T850-380H562Zm-326.5-56.5Q202-470 202-521t33.5-84.5Q269-639 320-639t84.5 33.5Q438-572 438-521t-33.5 84.5Q371-403 320-403t-84.5-33.5ZM80-190v-36q0-19 9-36t24-24q45-32 98.5-47.5T320-349q55 0 108 17t99 46q14 10 23.5 25.5T560-226v36q0 13-8.5 21.5T530-160H110q-13 0-21.5-8.5T80-190Zm55-41v11h370v-11q-39-26-90-42t-95-16q-44 0-95.5 16T135-231Zm227-248q16-16 16-42t-16-42q-16-16-42-16t-42 16q-16 16-16 42t16 42q16 16 42 16t42-16Zm-42-42Zm0 301Z"
		/>
	</svg>
);
